import { SystemGroupRoleEnum } from "../api/generated/graphql";

export const userIsAllowed = (
  requiredRole: SystemGroupRoleEnum,
  currentUserRole?: SystemGroupRoleEnum | null,
  isSuperadmin = false,
): boolean => {
  if (isSuperadmin) return true;

  switch (requiredRole) {
    case SystemGroupRoleEnum.Admin:
      return currentUserRole === SystemGroupRoleEnum.Admin;
    case SystemGroupRoleEnum.Supervisor:
      return (
        currentUserRole === SystemGroupRoleEnum.Admin || currentUserRole === SystemGroupRoleEnum.Supervisor
      );
    case SystemGroupRoleEnum.Editor:
      return (
        currentUserRole === SystemGroupRoleEnum.Admin ||
        currentUserRole === SystemGroupRoleEnum.Supervisor ||
        currentUserRole === SystemGroupRoleEnum.Editor
      );
    case SystemGroupRoleEnum.ReadOnly:
      return (
        currentUserRole === SystemGroupRoleEnum.Admin ||
        currentUserRole === SystemGroupRoleEnum.Supervisor ||
        currentUserRole === SystemGroupRoleEnum.Editor ||
        currentUserRole === SystemGroupRoleEnum.ReadOnly
      );

    default:
      return false;
  }
};
